/* CYGNUSS: scripts do tema, antes dentro do HTML de toda pagina (snippets/cyg-seo.liquid, ~47 KB).
   Em arquivo o navegador guarda e reaproveita o codigo ja compilado. Carregado com defer (roda depois de montar a pagina).
   Cada bloco fica isolado num try: um erro num bloco nao para os outros. */
/* ---- bloco 1 (antes inline no cyg-seo.liquid, linha 8) ---- */
try {
    document.addEventListener('DOMContentLoaded', function () { if (document.querySelector('header-component[transparent]')) document.documentElement.classList.add('cyg-transp'); });
  /* Carrossel de vídeos do PDP: toca só o que está na tela (economiza banda; clones/fora da viewport ficam pausados) */
  (function(){
    function initVs(){
      var vids=[].slice.call(document.querySelectorAll('[class*="lumin-video-swiper"] video, [class*="lumin-video-slider"] video'));
      if(!vids.length) return;
      var io=new IntersectionObserver(function(es){
        es.forEach(function(en){
          var v=en.target;
          if(en.isIntersecting){ v.muted=v.muted!==false?true:v.muted; v.play().catch(function(){}); }
          else if(!v.paused && v.muted){ v.pause(); }
        });
      },{threshold:0.3});
      vids.forEach(function(v){ if(v.muted!==false){ v.pause(); } io.observe(v); });
    }
    /* Social proof: nome alterna entre clientes (Judge.me reais quando carregam; senão padrão BR) */
    function initNameRotate(){
      var el=document.querySelector('[data-name-rotate]');
      if(!el||el.dataset.rotInit) return; el.dataset.rotInit='1';
      var names=['Michelle','Ana Paula','Juliana','Camila','Fernanda','Mariana','Patrícia','Larissa','Bianca','Aline'], i=0, relogio=0;
      function troca(){
        var real=[].slice.call(document.querySelectorAll('.jdgm-rev__author')).map(function(a){return a.textContent.trim().split(' ')[0];}).filter(function(n){return n&&n.length>2;});
        if(real.length>=3){ names=real.filter(function(v,x,arr){return arr.indexOf(v)===x;}); }
        i=(i+1)%names.length;
        el.style.transition='opacity .3s'; el.style.opacity='0';
        setTimeout(function(){ el.textContent=names[i]; el.style.opacity='1'; },300);
      }
      /* perf (09/10/2026): troca o nome so com ele na tela */
      new IntersectionObserver(function(es){
        if(es[0].isIntersecting){ if(!relogio) relogio=setInterval(troca,3500); }
        else if(relogio){ clearInterval(relogio); relogio=0; }
      },{threshold:0}).observe(el);
    }
    /* CYGNUSS 02/11/2026 (Guifa): tamanho lembrado, regra unica da pagina do produto (abaixo) e do Leve junto (cart-upsell.js).
       A ultima escolha de tamanho fica guardada pela letra ("G (44-46)" e "G (46 - 48)" = G) e abre marcada em todo produto;
       sem escolha, G; o produto sem esse tamanho cai no G e, sem G, no primeiro com estoque. */
    window.cygTam={
      letra:function(t){return String(t||'').split(/[\s(]/)[0].toUpperCase();},
      ler:function(){try{return localStorage.getItem('cyg_tam')||'';}catch(e){return '';}},
      gravar:function(t){var l=window.cygTam.letra(t); if(!l) return; try{localStorage.setItem('cyg_tam',l);}catch(e){}},
      /* lista = nomes dos tamanhos com estoque, na ordem do produto; devolve o nome a marcar */
      escolher:function(lista){
        var T=window.cygTam; function acha(l){return l?lista.filter(function(t){return T.letra(t)===l;})[0]:null;}
        return acha(T.ler())||acha('G')||lista[0]||null;
      }
    };
    /* Cards de variante v2: seletor de UNIDADES (1x/2x/3x) troca os cards de cor (kits) */
    function initVariantCards(vc){
      if(!vc||vc.__cyg) return vc&&vc.__cyg;
      var variants=JSON.parse(vc.querySelector('[data-vc-variants]').textContent);
      var units=[].slice.call(vc.querySelectorAll('.cyg-vc-un'));
      var cards=[].slice.call(vc.querySelectorAll('.cyg-vc-card'));
      var pills=[].slice.call(vc.querySelectorAll('.cyg-vc-pill'));
      /* layout lista (2026-07-10): o corpo (cards de cor + pills) é movido
         pra logo DEPOIS da row de tier selecionada, expandindo colado nela
         (visual do quantity-breaks nativo). Sem kits (units vazio) o corpo
         fica no lugar normal. */
      var body=vc.querySelector('.cyg-vc-body');
      var isList=vc.classList.contains('cyg-vc--list');
      var st={u:1,c:null,t:null,q:1};
      /* 30/10/2026: venda so por unidade + campanha 11.11 (data-vc-qtd): a faixa escolhe a QUANTIDADE da variante, nao um kit */
      var qtdModo=vc.hasAttribute('data-vc-qtd');
      /* 31/10/2026 (Guifa, modelo Toda Up): na faixa de 2 ou mais, uma linha por peca (foto, cor e tamanho) no lugar do painel unico */
      var lista=null,pecas=[],qAntes=1,tamFeito=false;
      function find(c,t){return variants.filter(function(v){return v.c===c&&v.t===t;})[0];}
      /* cor inicial do tier: a primeira que tem estoque nesse tier (antes pegava a primeira mesmo esgotada) */
      function temEstoque(c,u){return variants.some(function(v){return v.c===c&&v.u===u&&v.av;});}
      function firstColor(u){var ks=cards.filter(function(x){return +x.dataset.u===u;});var k=ks.filter(function(x){return temEstoque(x.dataset.cor,u);})[0]||ks[0];return k?k.dataset.cor:null;}
      function render(){
        units.forEach(function(b){
          var on=+b.dataset.u===(qtdModo?st.q:st.u);
          b.classList.toggle('sel',on);
          /* layout lista usa o CSS nativo do quantity-breaks — a classe
             --active liga o estilo de row selecionada (borda/radio) */
          b.classList.toggle('quantity-breaks__card--active',on);
        });
        cards.forEach(function(k){
          k.classList.toggle('hid',+k.dataset.u!==st.u);
          k.classList.toggle('sel',k.dataset.cor===st.c);
        });
        pills.forEach(function(p){
          var v=find(st.c,p.dataset.tam);
          p.classList.toggle('off',!v||!v.av);
          p.classList.toggle('sel',p.dataset.tam===st.t);
        });
        var lc=vc.querySelector('[data-vc-cor]'),lt=vc.querySelector('[data-vc-tam]');
        if(lc)lc.textContent=st.c||''; if(lt)lt.textContent=st.t||'';
        if(isList&&body&&units.length){
          var sb=units.filter(function(b){return +b.dataset.u===(qtdModo?st.q:st.u);})[0];
          if(sb&&sb.nextElementSibling!==body) sb.insertAdjacentElement('afterend',body);
        }
        if(qtdModo) montarLista();
      }
      /* linhas por peca: as cores sao as avulsas (foto do card de cor), os tamanhos os da variante de 1 unidade */
      function esc(s){return String(s==null?'':s).replace(/[&<>"]/g,function(ch){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[ch];});}
      var cores=cards.filter(function(k){return +k.dataset.u===1;}).map(function(k){var im=k.querySelector('img');return {c:k.dataset.cor,hex:k.dataset.hex||'',img:im?(im.currentSrc||im.src):''};});
      var tams=[];variants.forEach(function(v){if(v.u===1&&tams.indexOf(v.t)<0)tams.push(v.t);});
      /* CYGNUSS 31/10/2026 (Guifa): bolinha so com a cor no lugar da foto repetida (o nome fica em "Cor: X" da linha).
         A cor vem do mapa unico snippets/cyg-cor-hex (window.cygCorHex, layout/theme.liquid); cor sem mapa usa a foto. */
      function hexDe(x){return x.hex||(window.cygCorHex||{})[x.c]||'';}
      function bola(x,cls){var h=hexDe(x);return '<span class="'+cls+(h?'':' cyg-qbp__bola--foto')+'" aria-hidden="true"'+(h?' data-cyg-hex="'+esc(h)+'"':'')+'>'+(h?'':(x.img?'<img src="'+esc(x.img)+'" alt="">':''))+'</span>';}
      function letra(t){return String(t||'').split(/[\s(]/)[0];}
      /* tamanho (Guifa): a PRIMEIRA escolha na pagina vale para todas as pecas; depois cada uma fica com o seu.
         Toda escolha de tamanho fica lembrada pela regra unica window.cygTam (acima) e abre marcada no proximo produto. */
      function gravarTam(t){window.cygTam.gravar(t);}
      function tamCom(c){return window.cygTam.escolher(variants.filter(function(x){return x.u===1&&x.c===c&&x.av;}).map(function(x){return x.t;}));}
      function tamDaLetra(c,l){if(!l)return null;var v=variants.filter(function(x){return x.u===1&&x.c===c&&x.av&&letra(x.t).toUpperCase()===l;})[0];return v?v.t:null;}
      function primeiraEscolha(t){
        if(tamFeito) return false;
        tamFeito=true; gravarTam(t);
        var l=letra(t).toUpperCase();
        pecas.forEach(function(p){var n=tamDaLetra(p.c,l); if(n)p.t=n;});
        return true;
      }
      function linhaHtml(i,p){
        var nc=vc.dataset.opt1||'Cor',nt=vc.dataset.opt2||'Tamanho';
        var im=(cores.filter(function(x){return x.c===p.c;})[0]||cores[0]||{}).img||'';
        if(im&&window.cygFoto) im=window.cygFoto(im,'miniatura');
        var dots=cores.map(function(x){
          var on=x.c===p.c,tem=variants.some(function(v){return v.u===1&&v.c===x.c&&v.av;});
          return '<button type="button" role="radio" class="cyg-qbp__dot'+(on?' is-on':'')+'" data-cyg-pcor="'+esc(x.c)+'" aria-checked="'+on+'" aria-label="'+esc(x.c)+'" title="'+esc(x.c)+'"'+(tem?'':' disabled')+'>'+bola(x,'cyg-qbp__bola')+'</button>';
        }).join('');
        var ops=tams.map(function(t){var v=find(p.c,t);return '<option value="'+esc(t)+'"'+(t===p.t?' selected':'')+(!v||!v.av?' disabled':'')+'>'+esc(t)+'</option>';}).join('');
        return '<div class="cyg-qbp" data-cyg-peca="'+i+'">'+
          '<span class="cyg-qbp__thumb"><img src="'+esc(im)+'" alt="" width="56" height="72"></span>'+
          '<div class="cyg-qbp__col"><span class="cyg-qbp__lbl">'+esc(nc)+': <b>'+esc(p.c)+'</b></span><div class="cyg-qbp__dots" role="radiogroup" aria-label="'+esc(nc)+' da peça '+(i+1)+'">'+dots+'</div></div>'+
          '<div class="cyg-qbp__col"><span class="cyg-qbp__lbl">'+esc(nt)+'</span><select class="cyg-qbp__tam" data-cyg-ptam aria-label="'+esc(nt)+' da peça '+(i+1)+'">'+ops+'</select></div>'+
        '</div>';
      }
      function pintarHex(raiz){[].forEach.call(raiz.querySelectorAll('[data-cyg-hex]'),function(e){e.style.background=e.getAttribute('data-cyg-hex');});}
      /* o Adicionar do tema (product-form.js) le a faixa ativa: com data-variant-ids ele manda cada peca ao carrinho */
      function marcarIds(){
        units.forEach(function(b){b.removeAttribute('data-has-variant-pickers');b.removeAttribute('data-variant-ids');});
        if(st.q<2) return;
        var ativo=units.filter(function(b){return +b.dataset.u===st.q;})[0];
        var ids=pecas.slice(0,st.q).map(function(p){var v=find(p.c,p.t);return v&&v.av?v.id:0;});
        if(!ativo||ids.some(function(x){return !x;})) return;
        ativo.setAttribute('data-has-variant-pickers','true');
        ativo.setAttribute('data-variant-ids',ids.join(','));
      }
      function montarLista(){
        if(!isList||!units.length) return;
        /* 31/10/2026 (Guifa): o provador da Sizebay ("Qual meu tamanho?" e "Medidas") vai junto: com 1 peca fica no painel de sempre,
           acima do tamanho; com 2 ou mais sobe para o topo da lista das pecas (antes sumia com o painel escondido) */
        var szb=document.getElementById('szb-container');
        if(st.q<2){
          if(lista) lista.hidden=true; if(body) body.hidden=false;
          if(szb&&body&&szb.parentNode!==body) body.insertBefore(szb,body.querySelector('.cyg-sg-row'));
          qAntes=st.q; marcarIds(); return;
        }
        /* vindo de 1 peca, todas comecam na cor e no tamanho ja escolhidos; trocando 2 por 3, as primeiras ficam */
        if(qAntes<2) pecas=[];
        /* 31/10/2026 (Guifa): cada peca nova comeca numa cor diferente, na ordem da pilha de fotos da faixa (cor escolhida, depois as
           outras com estoque na ordem das cores); o tamanho e o escolhido, ou o mais parecido que a cor tem */
        while(pecas.length<st.q){ var cn=corLivre(pecas.map(function(p){return p.c;})); pecas.push({c:cn,t:tamPara(cn)}); }
        qAntes=st.q;
        if(!lista){ lista=document.createElement('div'); lista.className='cyg-qbp-lista'; }
        lista.innerHTML=pecas.slice(0,st.q).map(function(p,i){return linhaHtml(i,p);}).join('');
        if(szb) lista.insertBefore(szb,lista.firstChild);
        pintarHex(lista);
        var sb=units.filter(function(b){return +b.dataset.u===st.q;})[0];
        if(sb&&sb.nextElementSibling!==lista) sb.insertAdjacentElement('afterend',lista);
        lista.hidden=false; if(body) body.hidden=true;
        marcarIds();
      }
      function temCor(c){return variants.some(function(v){return v.u===1&&v.c===c&&v.av;});}
      function corLivre(usadas){
        if(usadas.indexOf(st.c)<0) return st.c;
        for(var k=0;k<cores.length;k++){ var c=cores[k].c; if(usadas.indexOf(c)<0&&temCor(c)) return c; }
        return st.c;
      }
      function tamPara(c){
        var v=find(c,st.t); if(v&&v.av) return st.t;
        var n=tamDaLetra(c,letra(st.t).toUpperCase()); if(n) return n;
        return tamCom(c)||st.t;
      }
      function trocarLinha(row,i){
        var tmp=document.createElement('div'); tmp.innerHTML=linhaHtml(i,pecas[i]);
        var novo=tmp.firstChild; pintarHex(novo); row.parentNode.replaceChild(novo,row); return novo;
      }
      function mudarPeca(row,c,t){
        var i=+row.getAttribute('data-cyg-peca'),p=pecas[i]; if(!p) return;
        if(t!=null) gravarTam(t);
        if(t!=null&&primeiraEscolha(t)){
          p.t=t; var nt=tamDaLetra(st.c,letra(t).toUpperCase()); if(nt) st.t=nt;
          [].forEach.call(lista.querySelectorAll('[data-cyg-peca]'),function(r){var k=+r.getAttribute('data-cyg-peca'); if(k!==i) trocarLinha(r,k);});
        }
        if(c!=null)p.c=c; if(t!=null)p.t=t;
        var v=find(p.c,p.t);
        if(!v||!v.av){ var alt=variants.filter(function(x){return x.u===1&&x.c===p.c&&x.av;})[0]; if(alt)p.t=alt.t; }
        var novo=trocarLinha(row,i);
        var foco=c!=null?novo.querySelector('.cyg-qbp__dot.is-on'):novo.querySelector('[data-cyg-ptam]');
        if(foco) foco.focus({preventScroll:true});
        marcarIds();
      }
      /* troca a variante do tema com UM change so: o seletor nativo le o atributo selected (nao o .value)
         e ignora opcao marcada como disabled; antes eram 2 changes e o 1o ficava com o selected velho */
      var escopo=vc.closest('.product-information, .shopify-section')||document;
      function setSel(s,val){[].forEach.call(s.options,function(o){var on=o.value===val;o.disabled=false;o.removeAttribute('disabled');o.selected=on;if(on)o.setAttribute('selected','selected');else o.removeAttribute('selected');});}
      function syncNative(id){
        var inp=escopo.querySelector('form[action*="/cart/add"] input[name=id]');
        if(inp) inp.value=id; /* o botao ja adiciona a variante certa mesmo antes da resposta do tema */
        var sels=[].slice.call(escopo.querySelectorAll('.variant-picker select'));
        if(sels.length>=2){ setSel(sels[0],st.c); setSel(sels[1],st.t); sels[1].dispatchEvent(new Event('change',{bubbles:true})); }
        else if(sels.length===1){ setSel(sels[0],st.c); sels[0].dispatchEvent(new Event('change',{bubbles:true})); }
        else if(inp){ inp.dispatchEvent(new Event('change',{bubbles:true})); }
      }
      /* o tema não re-renderiza o preço quando setamos input[name=id] — escreve direto no DOM */
      function updatePrice(v){
        if(!v||!v.pf) return;
        function aplica(root){
          if(!root) return;
          var comp=root.querySelector('.compare-at-price');
          var sale=[].slice.call(root.querySelectorAll('.money')).filter(function(m){return !m.closest('.compare-at-price');})[0];
          if(sale) sale.textContent=v.pf;
          if(comp){
            var div=root.querySelector(':scope > div')||root;
            var wrap=[].slice.call(div.children).filter(function(ch){return ch.contains(comp);})[0]||comp;
            var cm=comp.querySelector('.money')||comp;
            if(v.cp>v.p&&v.cf){ cm.textContent=v.cf; wrap.style.display=''; }
            else wrap.style.display='none';
          }
        }
        aplica(escopo.querySelector('.product-details product-price'));
        aplica(document.querySelector('.sticky-add-to-cart__price'));
        var pp=escopo.querySelector('.product-details product-price');
        var scope=pp?pp.parentElement:null;
        if(scope){
          var badge=[].slice.call(scope.querySelectorAll('*')).filter(function(el){
            return el.children.length===0&&/Economize/i.test(el.textContent||'');
          })[0];
          if(badge){
            if(v.cp>v.p){ badge.textContent='Economize '+Math.floor((1-v.p/v.cp)*100)+'%'; badge.style.display=''; }
            else badge.style.display='none';
          }
        }
      }
      function pick(){
        if(!st.c||cards.filter(function(k){return k.dataset.cor===st.c&&+k.dataset.u===st.u;}).length===0){ st.c=firstColor(st.u); }
        var v=find(st.c,st.t);
        /* cor sem o tamanho marcado: o lembrado, senao G, senao o primeiro com estoque (window.cygTam) */
        if(!v||!v.av){ var alt=tamCom(st.c)||(variants.filter(function(x){return x.c===st.c&&x.av;})[0]||{}).t; if(alt)st.t=alt; v=find(st.c,st.t); }
        render(); if(v){ syncNative(v.id); updatePrice(v); }
      }
      /* estado inicial = a variante que a pagina ja abriu (sem disparar troca de variante no carregamento) */
      var idIni=+((escopo.querySelector('form[action*="/cart/add"] input[name=id]')||{}).value||0);
      var f1=variants.filter(function(v){return v.id===idIni;})[0]||variants.filter(function(v){return v.u===1&&v.av;})[0]||variants[0];
      if(f1){st.c=f1.c;st.t=f1.t;st.u=f1.u||1;}
      /* venda so por unidade (sem a lista de quantidades): se a pagina abriu num kit, troca para a primeira cor avulsa */
      var un1=!units.length&&st.u!==1&&(variants.filter(function(v){return v.u===1&&v.av;})[0]||variants.filter(function(v){return v.u===1;})[0]);
      if(un1){st.c=un1.c;st.t=un1.t;st.u=1;render();syncNative(un1.id);updatePrice(un1);}
      else render();
      /* 01/11/2026 (Guifa): sem tamanho lembrado, o produto abre no G (quando a cor tem G com estoque).
         02/11/2026: produto sem o tamanho lembrado tambem cai no G e, sem G, no primeiro com estoque (window.cygTam) */
      var lemb=f1&&!un1&&tamCom(st.c);
      if(lemb&&lemb!==st.t){
        st.t=lemb; var vl=find(st.c,st.t);
        if(vl){ var inpL=escopo.querySelector('form[action*="/cart/add"] input[name=id]'); if(inpL) inpL.value=vl.id;
          var selsL=[].slice.call(escopo.querySelectorAll('.variant-picker select')); if(selsL.length>=2) setSel(selsL[1],st.t);
          updatePrice(vl); }
        render();
      }
      function campoQtd(){return escopo.querySelector('form[action*="/cart/add"] input[name=quantity]')||escopo.querySelector('.product-details input[name=quantity]');}
      if(qtdModo){
        var maxQ=units.reduce(function(m,b){return Math.max(m,+b.dataset.u);},1);
        /* o seletor de quantidade do tema tambem marca a faixa (4 ou mais fica na maior) */
        function lerQtd(){
          var q=campoQtd(); if(!q) return;
          var n=Math.min(Math.max(1,parseInt(q.value,10)||1),maxQ);
          if(n!==st.q){st.q=n;render();}
        }
        escopo.addEventListener('quantity-selector:update',lerQtd);
        escopo.addEventListener('change',lerQtd);
      }
      if(qtdModo){
        /* marca para o Adicionar do tema achar a faixa ativa (o preco do tema so muda com data-override-product-price, que nao vai) */
        var qbEl=vc.querySelector('.quantity-breaks'); if(qbEl) qbEl.setAttribute('data-quantity-breaks-component','');
        vc.addEventListener('change',function(e){
          var s=e.target.closest&&e.target.closest('[data-cyg-ptam]'); if(!s) return;
          mudarPeca(s.closest('[data-cyg-peca]'),null,s.value);
        });
      }
      vc.__cyg={clique:function(el){
        if(el.classList.contains('cyg-qbp__dot')){ mudarPeca(el.closest('[data-cyg-peca]'),el.getAttribute('data-cyg-pcor'),null); return; }
        if(qtdModo&&el.classList.contains('cyg-vc-un')){
          st.q=+el.dataset.u; render();
          var q=campoQtd();
          if(q&&+q.value!==st.q){
            q.value=st.q;
            var comp=q.closest('quantity-selector-component');
            if(comp&&comp.onQuantityChange){comp.onQuantityChange();if(comp.updateButtonStates)comp.updateButtonStates();}
          }
          return;
        }
        if(el.classList.contains('cyg-vc-un')){st.u=+el.dataset.u;st.c=null;}
        else if(el.classList.contains('cyg-vc-card')){st.c=el.dataset.cor;}
        else if(el.classList.contains('cyg-vc-pill')){st.t=el.dataset.tam; gravarTam(st.t); primeiraEscolha(st.t);}
        pick();
      }};
      /* trava a altura da área de cards no MAIOR tier — trocar quantidade não muda o tamanho.
         SÓ no layout cartões: na lista a trava criava um vão enorme abaixo
         das variantes quando o tier ativo tinha poucas cores. */
      var wrap=vc.querySelector('.cyg-vc-cards');
      var c0=cards[0];
      if(wrap&&c0&&!isList){
        var cw=c0.getBoundingClientRect().width||84, ch=c0.getBoundingClientRect().height||106, gap=10;
        var per=Math.max(1,Math.floor((wrap.clientWidth+gap)/(cw+gap)));
        var maxRows=1;
        for(var u=1;u<=6;u++){
          var n=cards.filter(function(k){return +k.dataset.u===u;}).length;
          if(n) maxRows=Math.max(maxRows,Math.ceil(n/per));
        }
        wrap.style.minHeight=(maxRows*(ch+2)+(maxRows-1)*gap)+'px';
      }
      return vc.__cyg;
    }
    /* um ouvinte so, ligado ja na leitura da pagina: o toque nas faixas/cores/tamanhos funciona desde o primeiro instante */
    document.addEventListener('click',function(e){
      var t=e.target.closest&&e.target.closest('.cyg-vc-un, .cyg-vc-card, .cyg-vc-pill, .cyg-qbp__dot');
      if(!t) return;
      var vc=t.closest('.cyg-vc'); if(!vc) return;
      var ctl=initVariantCards(vc); if(ctl) ctl.clique(t);
    });
    /* Instagram: carrossel infinito (marquee) com arraste */
    function initInstaMarquee(){
      var sec=document.querySelector('[id*="insta_cyg"]');
      if(!sec||sec.dataset.mq) return; sec.dataset.mq='1';
      var imgs=sec.querySelectorAll('img');
      if(imgs.length<3) return;
      /* FIX 2026-07-10: a heuristica antiga (parentElement.parentElement do
         1o img) pegava um elemento DENTRO do primeiro slide → o marquee
         rodava dentro do slide 1 enquanto o slider Lumin ficava congelado
         do lado = "duas galerias". O track real e o wrapper do slider. */
      var track=sec.querySelector('.lumin-slider-wrapper')||imgs[0].closest('[class*="track"]')||imgs[0].parentElement.parentElement;
      var wrap=sec.querySelector('.lumin-slider-viewport')||track.parentElement;
      wrap.classList.add('cyg-marquee-wrap'); track.classList.add('cyg-marquee-track');
      var kids=[].slice.call(track.children);
      kids.forEach(function(k){ track.appendChild(k.cloneNode(true)); });
      var x=0, half=0, drag=false, lx=0, vel=-0.5, visivel=false, quadro=0;
      function measure(){ half=track.scrollWidth/2; }
      setTimeout(measure,600);
      /* perf (09/10/2026): o laco so roda com a faixa na tela; fora dela para de vez (antes redesenhava 60x por segundo a pagina toda parada) */
      function tick(){
        if(!visivel){ quadro=0; return; }
        if(!drag){ x+=vel; }
        if(half>0){ if(x<=-half)x+=half; if(x>0)x-=half; }
        track.style.transform='translateX('+x+'px)';
        quadro=requestAnimationFrame(tick);
      }
      new IntersectionObserver(function(es){
        visivel=es[0].isIntersecting;
        if(visivel&&!quadro) quadro=requestAnimationFrame(tick);
      },{threshold:0}).observe(wrap);
      wrap.addEventListener('pointerdown',function(e){drag=true;lx=e.clientX;});
      window.addEventListener('pointermove',function(e){ if(drag){ x+=e.clientX-lx; lx=e.clientX; } },{passive:true});
      window.addEventListener('pointerup',function(){drag=false;});
    }
    /* Menu drawer mobile: ícone SVG antes de cada item */
    function initMenuIcons(){
      /* perf (09/10/2026): com o menu novo do celular (.cmm) o menu antigo fica escondido; nao gasta tempo nele */
      if(document.querySelector('.cmm')) return;
      var drawer=document.querySelector('.menu-drawer');
      if(!drawer||drawer.dataset.cygIcons) return; drawer.dataset.cygIcons='1';
      function svg(p){ return '<svg class="cyg-mi" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">'+p+'</svg>'; }
      var icons={
        'inicio': svg('<path d="M3 10.5 12 3l9 7.5"/><path d="M5 9.5V21h14V9.5"/>'),
        'categorias': svg('<rect x="3" y="3" width="7" height="7" rx="1.5"/><rect x="14" y="3" width="7" height="7" rx="1.5"/><rect x="3" y="14" width="7" height="7" rx="1.5"/><rect x="14" y="14" width="7" height="7" rx="1.5"/>'),
        'todas as colecoes': svg('<path d="m12 2 10 5-10 5L2 7z"/><path d="m2 17 10 5 10-5"/><path d="m2 12 10 5 10-5"/>'),
        'leggings': svg('<path d="M20.59 13.41 12 22 2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/><circle cx="7.5" cy="7.5" r="1.4"/>'),
        'maternidade': svg('<path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.6l-1-1a5.5 5.5 0 0 0-7.8 7.8l1 1L12 21.2l7.8-7.8 1-1a5.5 5.5 0 0 0 0-7.8z"/>'),
        'rastrear pedido': svg('<rect x="1" y="3" width="15" height="13" rx="1"/><path d="M16 8h4l3 4v4h-7z"/><circle cx="5.5" cy="18.5" r="2"/><circle cx="18.5" cy="18.5" r="2"/>'),
        'trocas e devolucoes': svg('<path d="M3 12a9 9 0 1 0 3-6.7"/><polyline points="3 2 3 8 9 8"/>'),
        'procurar': svg('<circle cx="11" cy="11" r="7"/><line x1="21" y1="21" x2="16.5" y2="16.5"/>')
      };
      var fallback=svg('<circle cx="12" cy="12" r="9"/><polyline points="10 8 14 12 10 16"/>');
      function norm(s){ return s.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'').trim(); }
      [].slice.call(drawer.querySelectorAll('.menu-drawer__menu-item-text')).forEach(function(sp){
        var a=sp.closest('a,summary'); if(!a||a.querySelector('.cyg-mi')) return;
        var ic=icons[norm(sp.textContent)]||fallback;
        sp.insertAdjacentHTML('beforebegin',ic);
      });
    }
    /* clique no vídeo abre em tela cheia (como no live) — setas e swipe vertical trocam de vídeo */
    function initVideoLightbox(){
      var slider=document.querySelector('.product-details [class*="lumin-video-swiper-inner"]');
      if(!slider||slider.dataset.vlb) return; slider.dataset.vlb='1';
      var overlay=document.createElement('div');
      overlay.className='cyg-vlb'; overlay.hidden=true;
      overlay.innerHTML='<button class="cyg-vlb-x" type="button" aria-label="Fechar">×</button>'
        +'<div class="cyg-vlb-nav">'
        +'<button type="button" data-vlb-prev aria-label="Vídeo anterior"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><polyline points="18 15 12 9 6 15"/></svg></button>'
        +'<button type="button" data-vlb-next aria-label="Próximo vídeo"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg></button>'
        +'</div><video playsinline loop></video>';
      document.body.appendChild(overlay);
      var vid=overlay.querySelector('video');
      var playlist=[], idx=0;
      function srcOf(w){ var s=w.querySelector('video source'); return s?s.src:((w.querySelector('video')||{}).currentSrc||''); }
      function buildPlaylist(){
        playlist=[].slice.call(document.querySelectorAll('.product-details [class*="lumin-video-swiper-slide"]:not([class*="clone"]) [class*="lumin-video-wrapper"]')).map(srcOf).filter(Boolean);
      }
      function show(i){
        if(!playlist.length) return;
        idx=((i%playlist.length)+playlist.length)%playlist.length;
        vid.src=playlist[idx]; vid.muted=false;
        vid.play().catch(function(){ vid.muted=true; vid.play().catch(function(){}); });
      }
      function close(){
        overlay.hidden=true; vid.pause(); vid.removeAttribute('src'); vid.load();
        document.documentElement.style.overflow='';
      }
      overlay.addEventListener('click',function(e){
        if(e.target.closest('[data-vlb-next]')){ show(idx+1); return; }
        if(e.target.closest('[data-vlb-prev]')){ show(idx-1); return; }
        if(e.target===overlay||e.target.closest('.cyg-vlb-x')) close();
      });
      /* swipe vertical: pra cima = próximo, pra baixo = anterior */
      var ty=0;
      overlay.addEventListener('touchstart',function(e){ ty=e.touches[0].clientY; },{passive:true});
      overlay.addEventListener('touchend',function(e){
        var dy=e.changedTouches[0].clientY-ty;
        if(dy<-50) show(idx+1); else if(dy>50) show(idx-1);
      });
      document.addEventListener('keydown',function(e){
        if(overlay.hidden) return;
        if(e.key==='Escape') close();
        if(e.key==='ArrowDown') show(idx+1);
        if(e.key==='ArrowUp') show(idx-1);
      });
      slider.addEventListener('click',function(e){
        var w=e.target.closest('[class*="lumin-video-wrapper"]');
        if(!w) return;
        var src=srcOf(w);
        if(!src) return;
        e.preventDefault(); e.stopPropagation();
        [].slice.call(document.querySelectorAll('.product-details video')).forEach(function(v){ if(!v.paused) v.pause(); });
        buildPlaylist();
        overlay.hidden=false;
        document.documentElement.style.overflow='hidden';
        show(Math.max(0,playlist.indexOf(src)));
      },true);
    }
    /* modal "+ opções de pagamento": Pix + parcelas (fator do live: 1.1392 em 8x) */
    function initPayModal(){
      if(document.body.dataset.payInit) return; document.body.dataset.payInit='1';
      var FACTOR_TOTAL=1.1392, MAX_N=8;
      var fmt=new Intl.NumberFormat('pt-BR',{style:'currency',currency:'BRL'});
      function currentPrice(){
        var el=document.querySelector('.product-details .price');
        if(!el) return 0;
        var vals=(el.textContent.match(/R\$\s?[\d\.]+,\d{2}/g)||[]).map(function(s){
          return parseFloat(s.replace(/[^\d,]/g,'').replace(',','.'));
        });
        return vals.length?Math.min.apply(null,vals):0;
      }
      function fill(modal){
        var p=currentPrice();
        if(!p) return;
        var pix=modal.querySelector('[data-pay-pix]');
        if(pix) pix.textContent=fmt.format(p);
        var list=modal.querySelector('[data-pay-list]');
        if(!list) return;
        var html='';
        for(var n=1;n<=MAX_N;n++){
          var fac=n===1?1:1+((n-1)*((FACTOR_TOTAL-1)/(MAX_N-1)));
          var tot=p*fac, parc=tot/n;
          html+='<div class="cyg-pay-row"><span>'+n+'x de <b>'+fmt.format(parc)+'</b>'+(n===1?' sem juros':'')+'</span><span class="tot">total '+fmt.format(tot)+'</span></div>';
        }
        list.innerHTML=html;
      }
      document.addEventListener('click',function(e){
        var btn=e.target.closest('.cyg-pay-btn');
        if(btn){
          var modal=document.querySelector('.cyg-pay-modal');
          if(modal){ fill(modal); modal.hidden=false; document.documentElement.style.overflow='hidden'; }
          return;
        }
        var modal=e.target.closest('.cyg-pay-modal');
        if(modal&&(e.target===modal||e.target.closest('.cyg-pay-close'))){
          modal.hidden=true; document.documentElement.style.overflow='';
        }
      });
    }
    /* sticky bar: preenche o pill de variante (como o select do live) */
    /* CYG-BARRA-FOLHA (13/10/2026, aprovada pelo Guifa: "tem que mostrar o desconto de levar mais unidade"):
       com o seletor de quantidade, cor e tamanho da pagina (.cyg-vc), a pilula da barra fixa vira botao e abre a folha por baixo
       do Leve junto (visual em snippets/cart-upsell.liquid, #209) no lugar da lista do aparelho. Cada toque na folha aciona o mesmo
       botao da pagina, entao pagina, preco e barra mudam juntos. Sem o .cyg-vc, segue o select invisivel de antes. */
    var cygFolhaBarra=(function(){
      var folha=null,veu=null,origem=null;
      var X='<svg viewBox="0 0 14 14" aria-hidden="true"><path d="M3 3l8 8M11 3l-8 8" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" fill="none"/></svg>';
      /* a sacola com "+" do botao de compra da pagina (icon-add-to-cart.svg) */
      var SACOLA='<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M16.608 9.421V6.906H3.392v8.016c0 .567.224 1.112.624 1.513.4.402.941.627 1.506.627H8.63M8.818 3h2.333c.618 0 1.212.247 1.649.686a2.35 2.35 0 0 1 .683 1.658v1.562H6.486V5.344c0-.622.246-1.218.683-1.658A2.33 2.33 0 0 1 8.82 3"/><path d="M14.608 12.563v5m2.5-2.5h-5"/></svg>';
      function esc(s){ return String(s==null?'':s).replace(/[&<>"]/g,function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }
      function fmt(c){ var s=(c/100).toFixed(2).split('.'); return 'R$ '+s[0].replace(/\B(?=(\d{3})+(?!\d))/g,'.')+','+s[1]; }
      function img(e){ var i=e&&e.querySelector('img'); return i?(i.currentSrc||i.src):''; }
      function vc(){ return document.querySelector('.product-details .cyg-vc')||document.querySelector('.cyg-vc'); }
      function idAtual(){ var i=document.querySelector('.product-details form input[name="id"], form[data-type="add-to-cart-form"] input[name="id"]'); return i?String(i.value):''; }
      /* CYGNUSS 03/11/2026: so o texto que aparece na pagina. O selo e o preco da campanha trazem as duas fases (c11-so-esquenta e
         c11-so-dia) e o CSS esconde a outra; o textContent juntava as duas ("Esquenta 11.11Oferta 11.11") */
      function mostra(el){ return !!el&&getComputedStyle(el).display!=='none'; }
      function texto(el){
        if(!el) return '';
        return [].map.call(el.childNodes,function(n){ return n.nodeType===3?n.nodeValue:(n.nodeType===1&&mostra(n)?texto(n):''); }).join('').replace(/\s+/g,' ').trim();
      }
      function visivel(raiz,sel){ return [].filter.call(raiz.querySelectorAll(sel),mostra)[0]||null; }
      function centavos(s){ var m=String(s||'').match(/(\d{1,3}(?:\.\d{3})*),(\d{2})/); return m?+(m[1].replace(/\./g,'')+m[2]):0; }
      function cria(){
        veu=document.createElement('div'); veu.className='cyg-ljf-veu cyg-ljf-veu--pagina'; veu.hidden=true;
        folha=document.createElement('div'); folha.className='cyg-ljf cyg-ljf--pagina'; folha.hidden=true; folha.tabIndex=-1;
        folha.setAttribute('role','dialog'); folha.setAttribute('aria-modal','true'); folha.setAttribute('aria-labelledby','cyg-ljf-pg-nome');
        document.body.appendChild(veu); document.body.appendChild(folha);
        veu.addEventListener('click',fecha);
        folha.addEventListener('click',clique);
        folha.addEventListener('change',troca);
        folha.addEventListener('keydown',tecla);
      }
      function monta(){
        var v=vc(); if(!v||!folha) return false;
        var vars=[]; try{ vars=JSON.parse(v.querySelector('[data-vc-variants]').textContent); }catch(e){}
        var id=idAtual(), atual=vars.filter(function(x){ return String(x.id)===id; })[0];
        var units=[].slice.call(v.querySelectorAll('.cyg-vc-un'));
        var uSel=units.filter(function(u){ return u.classList.contains('sel'); })[0];
        var uAt=uSel?+uSel.dataset.u:(atual?atual.u:1);
        /* venda so por unidade + campanha 11.11 (data-vc-qtd): a faixa e a QUANTIDADE da unidade, nao um kit. Cor e tamanho sao os da
           unidade; o preco de cada faixa e o que a pagina mostra (preco da oferta), nunca o do kit escondido */
        var qtd=v.hasAttribute('data-vc-qtd'), uCor=qtd?1:uAt;
        var cards=[].slice.call(v.querySelectorAll('.cyg-vc-card')).filter(function(k){ return +k.dataset.u===uCor; });
        var pills=[].slice.call(v.querySelectorAll('.cyg-vc-pill'));
        var cor=cards.filter(function(k){ return k.classList.contains('sel'); })[0];
        var tam=pills.filter(function(p){ return p.classList.contains('sel'); })[0];
        /* preco por peca de cada quantidade: o menor preco dela dividido pelas pecas, a mesma conta das ofertas da pagina
           (blocks/cyg-variant-cards.liquid); o desconto e contra a peca da menor quantidade (#226: preco por peca + 1 selo) */
        var tiers=units.map(function(u){
          var n=+u.dataset.u, fita=texto(visivel(u,'.quantity-breaks__recommended-badge, .pop'));
          if(qtd){
            var pr=centavos(texto(visivel(u,'.quantity-breaks__price, .pr')));
            return { n:n, peca:pr, disp:vars.some(function(x){ return x.u===1&&x.av; }), fita:fita };
          }
          var ps=vars.filter(function(x){ return x.u===n; });
          var min=ps.length?Math.min.apply(null,ps.map(function(x){ return x.p; })):0;
          return { n:n, peca:n?Math.floor(min/n):0, disp:ps.some(function(x){ return x.av; }), fita:fita };
        });
        /* com 2 ou mais pecas a pagina mostra uma linha por peca (cor e tamanho de cada uma): a folha mostra as mesmas linhas */
        var linhas=qtd&&uAt>1?[].slice.call(v.querySelectorAll('.cyg-qbp-lista:not([hidden]) [data-cyg-peca]')):[];
        var total=qtd&&uSel&&uAt>1?texto(visivel(uSel,'.cyg-qb-total')).replace(/^Total\s*/i,''):'';
        var menor=tiers.length?tiers.reduce(function(a,b){ return b.n<a.n?b:a; }):null;
        var nome=((document.querySelector('.sticky-add-to-cart__title')||{}).textContent||document.title).trim();
        var h='<div class="cyg-ljf__alca" aria-hidden="true"></div>'
          +'<div class="cyg-ljf__topo"><div class="cyg-ljf__foto"><img src="'+esc(img(cor)||img(document.querySelector('.sticky-add-to-cart__image')))+'" alt=""></div>'
          +'<div><p class="cyg-ljf__nome" id="cyg-ljf-pg-nome">'+esc(nome)+'</p><div class="cyg-ljf__linha"><span class="cyg-ljf__preco">'+esc(total||(atual?atual.pf:''))+'</span>'
          +(!total&&atual&&atual.cp>atual.p&&atual.cf?'<s class="cyg-ljf__de">'+esc(atual.cf)+'</s>':'')+'</div></div>'
          +'<button type="button" class="cyg-ljf__x" data-pg="fecha" aria-label="Fechar">'+X+'</button></div>';
        if(tiers.length>1){
          h+='<div class="cyg-ljf__g"><p class="cyg-ljf__rot">Quantidade</p><div class="cyg-ljf__segs cyg-ljf__segs--qtd" role="radiogroup" aria-label="Quantidade">'
            +tiers.map(function(t){
              var pct=menor&&menor.peca&&t!==menor?Math.floor((1-t.peca/menor.peca)*100):0;
              return '<button type="button" class="cyg-ljf__seg cyg-ljf__seg--qtd" role="radio" aria-checked="'+(t.n===uAt)+'"'+(t.disp?'':' disabled')+' data-pg="un" data-u="'+t.n+'">'
                +(t.fita?'<span class="cyg-ljf__fita">'+esc(t.fita)+'</span>':'')
                +'<span class="cyg-ljf__qtd">'+t.n+(t.n===1?' peça':' peças')+'</span>'
                +'<small>'+fmt(t.peca)+(t.n===1?'':'/un')+'</small>'
                +(pct>0?'<span class="cyg-ljf__selo">Economize '+pct+'%</span>':'')+'</button>';
            }).join('')+'</div></div>';
        }
        if(linhas.length){
          /* as linhas da pagina copiadas: cada toque aciona a mesma bolinha ou o mesmo tamanho dela (clique e troca abaixo) */
          h+='<div class="cyg-ljf__g cyg-qbp-lista cyg-ljf__pecas">'+linhas.map(function(r){ return r.outerHTML; }).join('')+'</div>';
          var pronto=!!(uSel&&uSel.getAttribute('data-variant-ids'));
          h+='<button type="button" class="cyg-ljf__cta" data-pg="comprar"'+(pronto?'':' disabled')+'>'+SACOLA+'<span>'+(pronto?'Adicionar ao carrinho':'Esgotado')+'</span></button>';
          folha.innerHTML=h;
          return true;
        }
        h+='<div class="cyg-ljf__g"><p class="cyg-ljf__rot">Cor: <b>'+esc(cor?cor.dataset.cor:'')+'</b></p><div class="cyg-ljf__trilho" role="radiogroup" aria-label="Cor">'
          +cards.map(function(k){
            var tem=vars.some(function(x){ return x.c===k.dataset.cor&&x.u===uCor&&x.av; });
            return '<button type="button" class="cyg-ljf__cor" role="radio" aria-checked="'+k.classList.contains('sel')+'"'+(tem?'':' disabled')+' data-pg="cor" data-cor="'+esc(k.dataset.cor)+'" data-u="'+esc(k.dataset.u)+'"><img src="'+esc(img(k))+'" alt="">'+esc(k.dataset.cor)+'</button>';
          }).join('')+'</div></div>';
        if(pills.length){
          h+='<div class="cyg-ljf__g"><p class="cyg-ljf__rot">Tamanho: <b>'+esc(tam?tam.dataset.tam:'')+'</b></p><div class="cyg-ljf__tams" role="radiogroup" aria-label="Tamanho">'
            +pills.map(function(p){
              var off=p.classList.contains('off');
              return '<button type="button" class="cyg-ljf__tam" role="radio" aria-checked="'+p.classList.contains('sel')+'"'+(off?' disabled':'')+' data-pg="tam" data-tam="'+esc(p.dataset.tam)+'">'+esc(p.textContent.trim())+'</button>';
            }).join('')+'</div></div>';
        }
        var pode=!!(atual&&atual.av);
        h+='<button type="button" class="cyg-ljf__cta" data-pg="comprar"'+(pode?'':' disabled')+'>'+SACOLA+'<span>'+(pode?'Adicionar ao carrinho':'Esgotado')+'</span></button>';
        folha.innerHTML=h;
        return true;
      }
      function abre(p){
        if(!folha) cria();
        if(!monta()) return;
        origem=p||null; veu.hidden=false; folha.hidden=false;
        document.documentElement.classList.add('cyg-ljf-trava');
        if(origem) origem.setAttribute('aria-expanded','true');
        requestAnimationFrame(function(){ veu.setAttribute('data-on',''); folha.setAttribute('data-on',''); folha.focus({preventScroll:true}); });
      }
      function fecha(){
        if(!folha||folha.hidden) return;
        veu.removeAttribute('data-on'); folha.removeAttribute('data-on');
        document.documentElement.classList.remove('cyg-ljf-trava');
        if(origem){ origem.setAttribute('aria-expanded','false'); origem.focus({preventScroll:true}); }
        setTimeout(function(){ veu.hidden=true; folha.hidden=true; },280);
      }
      /* linha da peca na pagina com o mesmo numero da linha tocada na folha */
      function linhaDaPagina(el){
        var r=el.closest('[data-cyg-peca]'), v=vc();
        return r&&v?v.querySelector('.cyg-qbp-lista [data-cyg-peca="'+r.getAttribute('data-cyg-peca')+'"]'):null;
      }
      function remonta(sel){
        setTimeout(function(){
          var y=folha.scrollTop; monta(); folha.scrollTop=y;
          var f=sel&&folha.querySelector(sel); if(f) f.focus({preventScroll:true});
        },60);
      }
      function troca(e){
        var s=e.target.closest&&e.target.closest('[data-cyg-ptam]'); if(!s) return;
        var r=linhaDaPagina(s), ps=r&&r.querySelector('[data-cyg-ptam]'); if(!ps) return;
        ps.value=s.value; ps.dispatchEvent(new Event('change',{bubbles:true}));
        remonta('[data-cyg-peca="'+r.getAttribute('data-cyg-peca')+'"] [data-cyg-ptam]');
      }
      function clique(e){
        var d=e.target.closest('.cyg-qbp__dot');
        if(d){
          if(d.disabled) return;
          var r=linhaDaPagina(d), pd=r&&[].filter.call(r.querySelectorAll('.cyg-qbp__dot'),function(x){ return x.getAttribute('data-cyg-pcor')===d.getAttribute('data-cyg-pcor'); })[0];
          if(pd){ pd.click(); remonta('[data-cyg-peca="'+r.getAttribute('data-cyg-peca')+'"] .cyg-qbp__dot.is-on'); }
          return;
        }
        var b=e.target.closest('[data-pg]'); if(!b||b.disabled) return;
        var k=b.dataset.pg, v=vc(), alvo=null;
        if(k==='fecha') return fecha();
        if(k==='comprar'){ var bt=document.querySelector('.sticky-add-to-cart__button'); fecha(); if(bt) bt.click(); return; }
        if(!v) return;
        if(k==='un') alvo=v.querySelector('.cyg-vc-un[data-u="'+b.dataset.u+'"]');
        if(k==='cor') alvo=[].filter.call(v.querySelectorAll('.cyg-vc-card'),function(x){ return x.dataset.cor===b.dataset.cor&&x.dataset.u===b.dataset.u; })[0];
        if(k==='tam') alvo=[].filter.call(v.querySelectorAll('.cyg-vc-pill'),function(x){ return x.dataset.tam===b.dataset.tam; })[0];
        if(!alvo) return;
        alvo.click(); /* o mesmo toque da pagina: troca a variante, o preco da pagina e o da barra */
        remonta('[data-pg="'+k+'"][aria-checked="true"]');
      }
      function tecla(e){
        if(e.key==='Escape'){ e.preventDefault(); fecha(); return; }
        if(e.key!=='Tab') return;
        /* o foco fica dentro da folha enquanto ela esta aberta */
        var fs=[].filter.call(folha.querySelectorAll('button, select'),function(b){ return !b.disabled; }); if(!fs.length) return;
        var i=fs.indexOf(document.activeElement);
        if(e.shiftKey&&i<=0){ e.preventDefault(); fs[fs.length-1].focus(); }
        else if(!e.shiftKey&&(i===-1||i===fs.length-1)){ e.preventDefault(); fs[0].focus(); }
      }
      /* faixa escolhida na pagina quando ela vende a QUANTIDADE da unidade (data-vc-qtd): numero de pecas e preco por peca que aparece */
      function faixaQtd(){
        var v=vc(); if(!v||!v.hasAttribute('data-vc-qtd')) return null;
        var u=v.querySelector('.cyg-vc-un.sel'); if(!u) return null;
        return { n:+u.dataset.u, peca:texto(visivel(u,'.quantity-breaks__price')).replace(/\s*\/un$/,'') };
      }
      return { abre:abre, temSeletor:function(){ return !!vc(); }, faixaQtd:faixaQtd };
    })();
    function initStickyVariantLabel(){
      if(document.body.dataset.cygStickyVar) return; document.body.dataset.cygStickyVar='1';
      function label(){
        var el=document.querySelector('.sticky-add-to-cart__variants');
        var inp=document.querySelector('.product-details form input[name="id"], form[data-type="add-to-cart-form"] input[name="id"]');
        if(!el||!inp||!inp.value) return;
        var id=String(inp.value);
        var comFolha=cygFolhaBarra.temSeletor();
        if(comFolha&&el.tagName!=='BUTTON'){
          /* a pilula vira um botao de verdade que abre a folha (teclado e leitor de tela) */
          var bt=document.createElement('button'); bt.type='button';
          [].forEach.call(el.attributes,function(a){ bt.setAttribute(a.name,a.value); });
          bt.setAttribute('aria-haspopup','dialog'); bt.setAttribute('aria-expanded','false');
          bt.addEventListener('click',function(){ cygFolhaBarra.abre(bt); });
          el.replaceWith(bt); el=bt;
        }
        var lab=el.querySelector('.cyg-sticky-label');
        if(!lab){
          el.textContent='';
          lab=document.createElement('span'); lab.className='cyg-sticky-label';
          el.appendChild(lab);
          if(!comFolha){
            /* sem o seletor da pagina: select real invisivel por cima (lista do aparelho, como no live) */
            var sel=document.createElement('select'); sel.className='cyg-sticky-select';
            el.appendChild(sel);
            sel.addEventListener('change',function(){
              var i2=document.querySelector('.product-details form input[name="id"], form[data-type="add-to-cart-form"] input[name="id"]');
              if(i2){ i2.value=sel.value; i2.dispatchEvent(new Event('change',{bubbles:true})); }
              setTimeout(label,200);
            });
          }
        }
        function go(vars){
          var v=vars.filter(function(x){return String(x.id)===id;})[0];
          /* rotulo curto na pilula (sem a medida entre parenteses): "Nude / M (42 - 44)" cortava no celular de 375 */
          var curto=v?v.title.replace(/\s*\([^)]*\)/g,''):'';
          /* CYGNUSS 03/11/2026: com 2 ou mais pecas (cada uma com cor e tamanho) a pilula diz quantas sao e o preco da barra e o da
             oferta por peca, o mesmo da faixa da pagina (antes ficava a cor da 1a peca e o preco de 1 unidade) */
          var fq=cygFolhaBarra.faixaQtd();
          if(fq){
            if(fq.n>1) curto=fq.n+' peças';
            var pb=document.querySelector('.sticky-add-to-cart__price .price');
            if(pb&&fq.peca&&pb.textContent!==fq.peca+'/un'){
              pb.textContent=fq.peca; var sm=document.createElement('small'); sm.textContent='/un'; pb.appendChild(sm);
            }
          }
          if(v&&lab.textContent!==curto){ lab.textContent=curto; if(el.tagName==='BUTTON') el.setAttribute('aria-label','Trocar quantidade, cor e tamanho: '+curto); }
          var sel2=el.querySelector('.cyg-sticky-select');
          if(sel2&&sel2.options.length===0){
            vars.forEach(function(x){ if(x.available){ sel2.add(new Option(x.title,x.id)); } });
          }
          if(sel2&&sel2.value!==id) sel2.value=id;
        }
        if(window.__cygVars){ go(window.__cygVars); }
        else if(!window.__cygVarsLoading){
          window.__cygVarsLoading=1;
          fetch(location.pathname.replace(/\/$/,'')+'.js').then(function(r){return r.json();}).then(function(p){ window.__cygVars=p.variants; go(p.variants); }).catch(function(){});
        }
      }
      document.addEventListener('variant:update',function(){ setTimeout(label,150); });
      document.addEventListener('change',function(){ setTimeout(label,150); });
      /* a faixa de quantidade da pagina muda so o campo de quantidade, sem change */
      document.addEventListener('click',function(e){ if(e.target.closest&&e.target.closest('.cyg-vc-un')) setTimeout(label,150); });
      label();
    }
    /* setas da galeria: esconde ← na primeira imagem e → na última */
    function initGalleryArrowEnds(){
      /* CYGNUSS 21/10/2026: so roda na pagina de produto; na colecao o [id$="__main"] e a grade e ler scrollWidth do 1o card forcava layout a toa */
      if(!document.querySelector('main[data-template^="product"]')) return;
      var main=document.querySelector('[id$="__main"]');
      if(!main||main.dataset.cygArrows) return; main.dataset.cygArrows='1';
      var slides=main.querySelectorAll('.product-media-container');
      if(!slides.length) return;
      var scroller=slides[0].parentElement;
      while(scroller&&scroller.scrollWidth<=scroller.clientWidth+10) scroller=scroller.parentElement;
      if(!scroller) return;
      var prev=main.querySelector('.slideshow-control--previous')||main.querySelectorAll('.slideshow-control')[0];
      var next=main.querySelector('.slideshow-control--next')||main.querySelectorAll('.slideshow-control')[1];
      /* as setas ficam onde o tema as pinta (o cyg.css ja as mostra no celular, com a seta unica do site); a de voltar
         nasce escondida e so aparece fora da primeira foto, sem nada aparecer e sumir ao carregar */
      function upd(){
        if(!prev||!prev.isConnected||!next||!next.isConnected){
          prev=main.querySelector('.slideshow-control--previous');
          next=main.querySelector('.slideshow-control--next');
        }
        if(!prev||!next) return;
        var max=scroller.scrollWidth-scroller.clientWidth;
        prev.classList.toggle('cyg-pode-voltar',scroller.scrollLeft>=10);
        next.classList.toggle('cyg-edge-hide',scroller.scrollLeft>max-10);
      }
      scroller.addEventListener('scroll',function(){ requestAnimationFrame(upd); },{passive:true});
      window.addEventListener('resize',function(){ requestAnimationFrame(upd); },{passive:true}); window.addEventListener('load',upd); setTimeout(upd,1500);
      upd();
    }
    /* "Feita com qualidade": pré-carrega as imagens (lazy nativo não antecipa scroll horizontal)
       e seta indicadora de scroll no mobile */
    function initQualityFix(){
      var sec=document.querySelector('[id$="__quality_cyg"]');
      if(!sec||sec.dataset.cygQual) return; sec.dataset.cygQual='1';
      var io=new IntersectionObserver(function(es){
        es.forEach(function(e){
          if(!e.isIntersecting) return;
          io.disconnect();
          sec.querySelectorAll('img').forEach(function(im){
            im.loading='eager';
            if(im.decode) im.decode().catch(function(){});
          });
          /* CYGNUSS 21/10/2026: a seta do celular so e montada quando a secao chega a 1200px da tela (antes era ao abrir a pagina, com leituras de layout a toa); ainda fora da vista, entao nada aparece atrasado */
          if(matchMedia('(max-width: 749px)').matches) montaSeta();
        });
      },{rootMargin:'1200px 0px'});
      io.observe(sec);
      function montaSeta(){
      if(window.innerWidth>=750) return;
      var sc=sec.querySelector('.layout-panel-flex--row.mobile-column');
      if(!sc) return;
      var host=sc.parentElement;
      host.style.position='relative';
      var b=document.createElement('button');
      b.type='button'; b.className='cyg-qual-next'; b.setAttribute('aria-label','Ver próximo');
      b.innerHTML='<svg width="17" height="17" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M6 2.5 11.5 8 6 13.5" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      host.appendChild(b);
      /* 14/10: seta no centro da FOTO (antes era o centro do card inteiro, foto + texto, e com a secao ainda
         sem tamanho pelo content-visibility caia no topo); refaz quando a foto ganha tamanho */
      function place(){
        var im=sc.querySelector('img');
        var hh=host.getBoundingClientRect().top;
        if(im&&im.offsetHeight){ var ir=im.getBoundingClientRect(); b.style.top=Math.round(ir.top-hh+ir.height/2)+'px'; }
        else b.style.top=(sc.offsetTop+Math.round(sc.offsetHeight/2))+'px';
        /* ancora na borda do VIEWPORT (o host tem padding lateral) */
        var hr=host.getBoundingClientRect().right;
        b.style.right=Math.round(hr-window.innerWidth+10)+'px';
      }
      place(); setTimeout(place,900);
      if(window.ResizeObserver){ var im0=sc.querySelector('img'); new ResizeObserver(function(){ requestAnimationFrame(place); }).observe(im0||sc); }
      b.addEventListener('click',function(){
        var card=sc.querySelector('.group-block');
        var step=card?card.getBoundingClientRect().width+17:Math.round(sc.clientWidth*0.7);
        sc.scrollBy({left:step,behavior:'smooth'});
      });
      function updQ(){ var max=sc.scrollWidth-sc.clientWidth; b.classList.toggle('cyg-edge-hide',sc.scrollLeft>max-10); }
      sc.addEventListener('scroll',function(){ requestAnimationFrame(updQ); },{passive:true});
      updQ();
      }
    }
    /* thumbnails laterais (desktop): dimensiona para caber exatamente 4 na coluna */
    function initThumbs4(){
      /* CYGNUSS 21/10/2026: miniaturas laterais sao so do computador; no celular nao le clientHeight, so espera a tela passar de 750px (um ouvinte so, mesmo com as duas chamadas do boot) */
      var mq=matchMedia('(min-width: 750px)');
      if(!mq.matches){ if(!initThumbs4.espera){ initThumbs4.espera=1; mq.addEventListener('change',function f(ev){ if(ev.matches){ mq.removeEventListener('change',f); initThumbs4(); } }); } return; }
      var cont=document.querySelector('[id$="__main"] .slideshow-controls__thumbnails-container');
      if(!cont||cont.dataset.cyg4) return; cont.dataset.cyg4='1';
      function size(){
        var h=cont.clientHeight;
        if(!h||h<200) return;
        var bh=Math.floor((h-3*8)/4);
        [].slice.call(cont.querySelectorAll('button')).forEach(function(b){
          b.style.height=bh+'px';
          b.style.width=Math.round(bh*0.8)+'px';
          b.style.flex='0 0 auto';
        });
      }
      size();
      window.addEventListener('resize',size);
      setTimeout(size,1500);
      setTimeout(size,4000);
    }
    function cygBoot(){
      setTimeout(initVs,800); setTimeout(initNameRotate,1200); document.querySelectorAll('.cyg-vc').forEach(function(v){initVariantCards(v);});
      /* CYGNUSS 21/10/2026: o marquee do Instagram so liga quando a faixa chega perto da tela (uma tela de folga), mantendo o minimo de 1,5s depois do boot para o slider Lumin iniciar antes (evita as "duas galerias") */
      var ig=document.querySelector('[id*="insta_cyg"]');
      if(ig){ var t0ig=performance.now(); var ioIg=new IntersectionObserver(function(es){ if(!es[0].isIntersecting) return; ioIg.disconnect(); setTimeout(initInstaMarquee, Math.max(0,1500-(performance.now()-t0ig))); },{rootMargin:'100% 0px'}); ioIg.observe(ig); }
      setTimeout(initVideoLightbox,1000); setTimeout(initPayModal,300); setTimeout(initStickyVariantLabel,1200); setTimeout(initGalleryArrowEnds,200); setTimeout(initQualityFix,600); initThumbs4(); setTimeout(initThumbs4,400);
      /* drawer pode ser montado tarde: tenta algumas vezes + no clique do hambúrguer */
      [400,1500,4000].forEach(function(t){ setTimeout(initMenuIcons,t); });
      document.addEventListener('click',function(e){ if(e.target.closest('.header__icon--menu')){ setTimeout(initMenuIcons,150); } },true);
    }
    /* boot no DOMContentLoaded — esperar o load atrasa demais em página cheia de vídeos
       (drawer aberto cedo ficava sem as transformações) */
    if(document.readyState!=='loading'){ cygBoot(); }
    else{ document.addEventListener('DOMContentLoaded',cygBoot); }
  })();
} catch (e) { console.error('[cyg] bloco 1', e); }

/* ---- bloco 4 (antes inline no cyg-seo.liquid, linha 527) ---- */
try {
  /* CYG-RODADA3: contador "1 / N" no lugar das bolinhas quando ha muitas fotos */
  (function () {
    function liga(ol) {
      if (ol.dataset.cygCount) return;
      var btns = [].slice.call(ol.querySelectorAll('button'));
      if (btns.length <= 5) return;
      ol.dataset.cygCount = '1';
      var pill = document.createElement('div');
      pill.className = 'cyg-count'; pill.setAttribute('aria-hidden', 'true');
      ol.parentNode.insertBefore(pill, ol);
      function atual() {
        var i = btns.findIndex(function (b) { return b.getAttribute('aria-selected') === 'true'; });
        pill.textContent = (i < 0 ? 1 : i + 1) + ' / ' + btns.length;
      }
      new MutationObserver(atual).observe(ol, { attributes: true, subtree: true, attributeFilter: ['aria-selected'] });
      atual();
    }
    function varre() { document.querySelectorAll('.slideshow-controls__dots').forEach(liga); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', varre); else varre();
    setTimeout(varre, 1500); setTimeout(varre, 4000);
  })();
} catch (e) { console.error('[cyg] bloco 4', e); }

/* ---- bloco 5 (antes inline no cyg-seo.liquid, linha 570) ---- */
try {
  /* CYG-MENU-JS (07/10/2026): icones configuraveis (Tema > Menu Cygnuss > cy_menu_icons) e vitrine que muda ao passar o mouse */
  (function () {
    var MAP = window.CYG_MENU_ICONS || '';
    /* 13/10 tarde ("os icones daqui nao fazem sentido alguns"): sutia com bojos e alcas, calcinha, body, short, modelador de cintura
       alta e legging de perna longa, no mesmo traco 1,6 e 24x24 dos outros (Mineiro #116, #209) */
    var IC = {
      sutia: 'M7 4v5 M17 4v5 M3 13c0-2.5 2-4 4-4s4 1.5 5 3.5C13 10.5 15 9 17 9s4 1.5 4 4c0 2.5-2 4-4.5 4-2 0-3.5-1.5-4.5-3-1 1.5-2.5 3-4.5 3C5 17 3 15.5 3 13z',
      calcinha: 'M3 7h18l-1 3c-3 .5-5.5 3.5-6.5 8h-3C9.5 13.5 7 10.5 4 10z',
      body: 'M8.5 3l.5 5 M15.5 3l-.5 5 M7 8h10l-.5 6 2 3-3.5 4h-6L5.5 17l2-3z',
      short: 'M5 5h14l1 13h-6.5L12 12l-1.5 6H4z M5 8h14',
      modelador: 'M7 3h10l-.5 7c0 2 1 3.5 2.5 5l-3 5h-4L12 16l-.5 4h-4l-3-5c1.5-1.5 2.5-3 2.5-5z M7.5 6h9',
      maternidade: 'M12 20s-7-4.5-7-10a4 4 0 0 1 7-2.5A4 4 0 0 1 19 10c0 5.5-7 10-7 10z',
      esportivo: 'M13 3L5 14h6l-1 7 8-11h-6z',
      estrela: 'M12 3l2.7 5.6 6.1.9-4.4 4.3 1 6.1L12 17l-5.4 2.9 1-6.1L3.2 9.5l6.1-.9z',
      etiqueta: 'M20.6 13.4 13.4 20.6a2 2 0 0 1-2.8 0L3 13V3h10l7.6 7.6a2 2 0 0 1 0 2.8z M7.5 7.5h.01',
      colecao: 'M4 4h7v7H4z M13 4h7v7h-7z M4 13h7v7H4z M13 13h7v7h-7z',
      legging: 'M7 3h10l1 18h-4l-2-12-2 12H6z M7 6h10'
    };
    var rules = [];
    String(MAP || '').split(/\n/).forEach(function (l) { var p = l.split('|'); if (p.length > 1 && p[0].trim()) rules.push([p[0].trim().toLowerCase(), p[1].trim().toLowerCase()]); });
    function iconFor(txt) { txt = txt.toLowerCase(); for (var i = 0; i < rules.length; i++) { if (txt.indexOf(rules[i][0]) > -1) return rules[i][1]; } return null; }
    function svg(n) { var d = IC[n]; if (!d) return null; var s = document.createElement('span'); s.className = 'cyg-mm__ico'; s.setAttribute('aria-hidden', 'true'); s.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="' + d + '"/></svg>'; return s; }
    function icons(root) {
      root.querySelectorAll('.mega-menu__link-title, .menu-drawer__menu-item-text').forEach(function (t) {
        if (t.querySelector('.cyg-mm__ico')) return;
        var n = iconFor((t.firstChild && t.firstChild.textContent || t.textContent).trim()); var s = n && svg(n); if (s) t.insertBefore(s, t.firstChild);
      });
    }
    /* VITRINE SEM TRAVAR (10/10/2026): cada categoria tem a sua vitrine, montada UMA vez com o molde leve
       collection.cyg-mm (~1 KB). Passar o mouse so troca qual vitrine aparece: nada de refazer as fotos e o texto
       a cada item, nem de medir a altura de novo (o painel tinha o texto piscando e o processador ocupado). */
    var dados = {};
    function urlDe(href) { var u = String(href || '').split('?')[0].replace(/\/$/, ''); if (!/\/collections\/[^/]+$/.test(u)) u = '/collections/mais-vendidos'; return u; }
    function busca(u) {
      /* sem cabecalho Accept: application/json, senao a Shopify devolve a ficha inteira no lugar do molde */
      return dados[u] || (dados[u] = fetch(u + '?view=cyg-mm').then(function (r) { return r.ok ? r.text() : '[]'; }).then(function (t) { try { return JSON.parse(t); } catch (e) { return []; } }).catch(function () { return []; }));
    }
    function foto(u, w) { if (!u) return ''; if (u.indexOf('//') === 0) u = 'https:' + u; u = u.replace(/([?&])width=\d+&?/, '$1').replace(/[?&]$/, ''); return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
    function esc(s) { return String(s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;'); }
    function nomeDe(a) { var t = a.querySelector('.mega-menu__link-title'), nm = ''; if (t) t.childNodes.forEach(function (n) { if (n.nodeType === 3) nm += n.textContent; }); return nm.replace(/\s+/g, ' ').trim(); }
    function painel(view, a) {
      var href = a.getAttribute('href') || '', u = urlDe(href);
      var pn = view.querySelector('.cyg-mm__painel[data-u="' + u + '"]');
      if (pn) return pn;
      pn = document.createElement('div'); pn.className = 'cyg-mm__painel is-vago'; pn.dataset.u = u;
      var nm = nomeDe(a);
      pn.innerHTML = '<p class="cyg-mm__lbl">MAIS PROCURADOS</p><div class="cyg-mm__grid">' + '<span class="cyg-mm__pc cyg-mm__pc--vago"><i></i><b></b><b></b></span>'.repeat(4) + '</div><a class="cyg-mm__all" href="' + esc(href) + '">Ver todos' + (nm ? ' em ' + esc(nm) : '') + '</a>';
      view.appendChild(pn);
      busca(u).then(function (ps) {
        var g = pn.querySelector('.cyg-mm__grid');
        if (!ps.length) { g.remove(); pn.classList.remove('is-vago'); return; }
        g.innerHTML = ps.map(function (p) {
          return '<a class="cyg-mm__pc" href="/products/' + esc(p.h) + '"><img src="' + esc(foto(p.i, 400)) + '" srcset="' + esc(foto(p.i, 260)) + ' 260w, ' + esc(foto(p.i, 400)) + ' 400w, ' + esc(foto(p.i, 600)) + ' 600w" sizes="190px" width="400" height="500" alt="" decoding="async"><p>' + esc(p.t) + '</p><span>' + (p.c ? '<s>' + esc(p.c) + '</s>' : '') + esc(p.p) + '</span></a>';
        }).join('');
        pn.classList.remove('is-vago');
      });
      return pn;
    }
    function show(view, a) {
      var pn = painel(view, a);
      view.querySelectorAll('.cyg-mm__painel.is-on').forEach(function (x) { if (x !== pn) x.classList.remove('is-on'); });
      pn.classList.add('is-on');
    }
    function build(m) {
      var grid = m.querySelector('.mega-menu__grid'); if (!grid || grid.classList.contains('cyg-mm-on') || !grid.querySelector('.cy-menu-extra')) return;
      var links = [].slice.call(grid.querySelectorAll('.mega-menu__list a.mega-menu__link')); if (!links.length) return;
      var rail = document.createElement('nav'); rail.className = 'cyg-mm__rail'; rail.setAttribute('aria-label', 'Categorias');
      links.forEach(function (a) { rail.appendChild(a); });
      var view = document.createElement('div'); view.className = 'cyg-mm__view';
      grid.insertBefore(view, grid.firstChild); grid.insertBefore(rail, grid.firstChild); grid.classList.add('cyg-mm-on');
      icons(rail);
      function on(a) { rail.querySelectorAll('.is-on').forEach(function (x) { x.classList.remove('is-on'); }); a.classList.add('is-on'); show(view, a); }
      links.forEach(function (a) { a.addEventListener('mouseenter', function () { on(a); }); a.addEventListener('focus', function () { on(a); }); });
      /* a primeira vitrine so e montada quando a cliente chega no Categorias (antes baixava em toda pagina, com o menu fechado) */
      var first = links.filter(function (a) { return /sutia|sutiã/i.test(a.textContent); })[0] || links[0];
      var item = m.closest('.menu-list__list-item'), abriu = false;
      /* ao chegar no Categorias: monta a primeira vitrine e ja busca o resumo das outras (~1 KB cada), para a troca ser na hora */
      var abre = function () { if (abriu) return; abriu = true; on(first); links.forEach(function (a) { busca(urlDe(a.getAttribute('href'))); }); };
      if (item) { item.addEventListener('pointerenter', abre); item.addEventListener('focusin', abre); } else abre();
    }
    function init() { document.querySelectorAll('.mega-menu').forEach(build); icons(document); }
    init(); document.addEventListener('DOMContentLoaded', init); setTimeout(init, 1500);
    /* refaz icones e vitrine so quando o cabecalho muda de verdade; as vitrines que a gente mesmo monta ficam de fora
       (cada vitrine nova disparava uma varredura da pagina inteira, e o mouse descendo pela lista travava) */
    var tm; (function (go) { if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', go); else go(); })(function () { var alvo = document.querySelector('header-component') || document.body; new MutationObserver(function (ms) { if (ms.every(function (m) { return m.target.closest && m.target.closest('.cyg-mm__view'); })) return; clearTimeout(tm); tm = setTimeout(init, 120); }).observe(alvo, { childList: true, subtree: true }); init(); });
  })();
} catch (e) { console.error('[cyg] bloco 5', e); }

/* ---- bloco 6 (antes inline no cyg-seo.liquid, linha 636) ---- */
try {
  /* CYG-CART-JS (08/10/2026): a gaveta do carrinho ja vem pronta do servidor (tamanho e cor, cupom, Frete, linha do cupom, Total, parcelado).
     Aqui fica so o toque que abre o campo do cupom. */
  (function () {
    document.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      /* "+ Adicionar cupom de desconto" no fim da lista e o + da linha do cupom abrem o campo pelo botao do proprio tema (escondido) */
      if (e.target.closest('.cyg-cupom-add, .cyg-cupom-mais')) {
        var tg = document.querySelector('.cart-drawer__summary .cart-discount .disclosure-trigger'); if (tg) tg.click();
        return;
      }
      /* com cupom ja aplicado o tema deixa o campo aberto; so mostramos quando a cliente toca */
      var t = e.target.closest('.cart-drawer__summary .cart-discount .disclosure-trigger'); if (!t) return;
      var cd = t.closest('.cart-discount');
      if (t.getAttribute('aria-expanded') === 'true') { e.preventDefault(); e.stopImmediatePropagation(); }
      cd.classList.add('cyg-user-open');
      setTimeout(function () { var i = cd.querySelector('.cart-discount__input'); if (i) i.focus(); }, 60);
    }, true);
  })();
} catch (e) { console.error('[cyg] bloco 6', e); }

/* ---- bloco 7 (antes inline no cyg-seo.liquid, linha 656) ---- */
try {
  /* CYG-ARRASTE-JS: nos carrosseis do celular sem setas, uma seta pisca 3 vezes quando o carrossel aparece;
     se a cliente arrastar antes, a seta some na hora (Mineiro #225) */
  (function () {
    if (!window.matchMedia || !window.matchMedia('(max-width: 749px)').matches || !('IntersectionObserver' in window)) return;
    var CAND = '.slideshow-controls__thumbnails-container, .layout-panel-flex--row, .jdgm-review-list, .resource-list, .cyg-vc-cards';
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) {
        if (!en.isIntersecting) return;
        io.unobserve(en.target);
        var sc = en.target, host = sc.parentElement;
        if (!host || sc.scrollLeft > 4 || sc.scrollWidth <= sc.clientWidth + 24) return;
        /* 14/10: carrossel que ja tem seta propria (ex.: a das 3 fotos) nao ganha a seta de arrastar: ficavam duas */
        if (host.querySelector('.cyg-qual-next, .slideshow-control')) return;
        var s = document.createElement('span'); s.className = 'cyg-arraste'; s.setAttribute('aria-hidden', 'true');
        host.classList.add('cyg-arraste-host'); host.appendChild(s);
        var tira = function () { s.classList.add('is-fora'); setTimeout(function () { s.remove(); }, 300); sc.removeEventListener('scroll', tira); sc.removeEventListener('pointerdown', tira); };
        s.addEventListener('animationend', function () { s.remove(); });
        sc.addEventListener('scroll', tira, { passive: true }); sc.addEventListener('pointerdown', tira, { passive: true });
      });
    }, { threshold: 0.6 });
    function procura() {
      document.querySelectorAll('main ' + CAND.split(', ').join(', main ')).forEach(function (el) {
        if (el.dataset.cygArraste) return;
        if (el.closest('slideshow-component:has(slideshow-arrows), .swiper, [class*="swiper"]')) return;
        var cs = getComputedStyle(el);
        if (cs.overflowX !== 'auto' && cs.overflowX !== 'scroll') return;
        if (el.scrollWidth <= el.clientWidth + 24 || el.getBoundingClientRect().height < 40) return;
        el.dataset.cygArraste = '1'; io.observe(el);
      });
    }
    if (document.readyState === 'complete') procura(); else window.addEventListener('load', procura);
    setTimeout(procura, 4000);
  })();
} catch (e) { console.error('[cyg] bloco 7', e); }

/* ---- bloco 8 (antes inline no cyg-seo.liquid, linha 690) ---- */
try {
  /* CYG-BARRAS-JS: anima as barras quando aparecem na tela */
  (function () {
    function go() {
      var els = [].slice.call(document.querySelectorAll('.cyg-bars__fg')).filter(function (e) { return !e.style.width; });
      if (!els.length) return;
      /* largura final ja na hora (escondida pelo recorte); a animacao so revela, sem recalcular a pagina a cada quadro */
      els.forEach(function (e) { e.style.width = e.getAttribute('data-w') + '%'; });
      function mostra(e) { e.classList.add('is-on'); }
      if (!('IntersectionObserver' in window)) { els.forEach(mostra); return; }
      /* observa o trilho: a barra recortada conta so a parte visivel (12px, ~4%) e nunca chegaria aos 40% */
      var io = new IntersectionObserver(function (es) { es.forEach(function (en) { if (en.isIntersecting) { var bar = en.target.querySelector('.cyg-bars__fg'); if (bar) mostra(bar); io.unobserve(en.target); } }); }, { threshold: .4 });
      els.forEach(function (e) { io.observe(e.parentElement || e); });
    }
    document.addEventListener('DOMContentLoaded', go); setTimeout(go, 1500);
    setTimeout(function () { document.querySelectorAll('.cyg-bars__fg').forEach(function (e) { if (!e.style.width) e.style.width = e.getAttribute('data-w') + '%'; e.classList.add('is-on'); }); }, 6000);
  })();
} catch (e) { console.error('[cyg] bloco 8', e); }

/* ---- bloco 9 (antes inline no cyg-seo.liquid, linha 708) ---- */
try {
  /* CYG-HERO-FOTOS-JS: monta a faixa de fotos que passa sozinha no banner com frase (so quando ha 2+ fotos) */
  (function () {
    function go() {
      document.querySelectorAll('[id*="__hero_"] .hero__media-wrapper:not(.cyg-hf)').forEach(function (w) {
        if (!w.closest('.hero') || !w.closest('.hero').querySelector('marquee-component')) return;
        var imgs = [].slice.call(w.querySelectorAll(':scope > img'));
        if (imgs.length < 2) return;
        var tr = document.createElement('div'); tr.className = 'cyg-hf__track';
        var set = imgs.concat(imgs);
        set.concat(set).forEach(function (im, k) { var c = k < imgs.length ? im : im.cloneNode(true); /* CYGNUSS PERF: sem forcar eager (a faixa fica no fim da home) */ if (k >= imgs.length) c.setAttribute('aria-hidden', 'true'); tr.appendChild(c); });
        w.appendChild(tr); w.classList.add('cyg-hf');
      });
    }
    document.addEventListener('DOMContentLoaded', go); setTimeout(go, 1200);
  })();
} catch (e) { console.error('[cyg] bloco 9', e); }

/* ---- bloco 10 (antes inline no cyg-seo.liquid, linha 725) ---- */
try {
  /* CYG-COR-CHROME: a barra do navegador no celular pega a cor da faixa de aviso do topo (a primeira faixa acima do cabecalho) */
  (function () {
    var vazio = function (c) { return !c || /^rgba\(0, 0, 0, 0\)$|transparent/.test(c.trim()); };
    function cor() {
      /* CYGNUSS 29/10/2026: na campanha 11.11 a faixa do topo e a .c11-faixa, que fica fora do header-group; antes a barra ficava branca */
      var c11 = document.querySelector('.c11-faixa'), g = document.getElementById('header-group');
      var faixa = c11 && c11.offsetHeight > 0 ? c11 : g && [].slice.call(g.children).find(function (s) { return s.offsetHeight > 0 && !s.querySelector('header-component'); });
      if (!faixa) return;
      var alvo = faixa.querySelector('[class*="color-scheme"], [class*="color-"]') || faixa, bg = '';
      for (var el = alvo; el && el !== document.body && vazio(bg); el = el.parentElement) bg = getComputedStyle(el).backgroundColor;
      if (vazio(bg)) bg = getComputedStyle(alvo).getPropertyValue('--color-background');
      if (vazio(bg)) return;
      var m = document.querySelector('meta[name="theme-color"]'); if (!m) { m = document.createElement('meta'); m.name = 'theme-color'; document.head.appendChild(m); }
      if (m.content !== bg.trim()) m.content = bg.trim();
      /* o header repinta a barra com a cor dele ao rolar; passa a usar a mesma cor da faixa */
      var h = document.querySelector('header-component'); if (h) h.dataset.themeColor = bg.trim();
    }
    /* CYGNUSS 21/10/2026: o script e defer e roda logo antes do DOMContentLoaded; antes cor() rodava duas vezes seguidas (dois layouts forcados), agora roda uma so */
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', cor); else cor();
    document.addEventListener('shopify:section:load', cor);
  })();
} catch (e) { console.error('[cyg] bloco 10', e); }

/* ---- bloco 11 (antes inline no cyg-seo.liquid, linha 745) ---- */
try {
  /* CYG-COMBO-MAIS: no celular a lista do combo mostra 4 pecas; o botao "Ver mais N pecas" vem do servidor e este toque abre e fecha */
  document.addEventListener('click', function (e) {
    var bt = e.target.closest && e.target.closest('.cyg-more[data-cyg-mais]'); if (!bt) return;
    var g = bt.previousElementSibling; if (!g || !g.classList.contains('bundle-deals__products')) return;
    var on = g.classList.toggle('cyg-all');
    bt.textContent = on ? 'Ver menos' : bt.getAttribute('data-cyg-mais');
    bt.setAttribute('aria-expanded', on ? 'true' : 'false');
  });
} catch (e) { console.error('[cyg] bloco 11', e); }

/* ---- bloco 12: fotos da pilha das faixas (2 e 3 unidades) sem o fundo branco ---- */
try {
  /* CYGNUSS 31/10/2026 (Guifa: "borda branca ao redor"): as fotos ja vem com fundo branco, e na pilha o branco da foto da frente
     cobria a de tras. Cada fotinho (40 px) e recortada aqui: o branco ligado a borda da foto vira transparente (os brancos dentro
     do sutia ficam) e a beirada clara do recorte fica meio transparente. Sem leitura da imagem (CORS), fica como estava. */
  (function () {
    function claro(p, i, lim) { var r = p[i], g = p[i + 1], b = p[i + 2], mn = Math.min(r, g, b); return mn >= lim && Math.max(r, g, b) - mn <= 16; }
    function recorta(img) {
      if (img.dataset.cygRec) return;
      img.dataset.cygRec = '1';
      var im = new Image();
      im.crossOrigin = 'anonymous';
      im.onload = function () {
        try {
          var w = im.naturalWidth, h = im.naturalHeight; if (!w || !h) return;
          var c = document.createElement('canvas'); c.width = w; c.height = h;
          var x = c.getContext('2d'); x.drawImage(im, 0, 0);
          var d = x.getImageData(0, 0, w, h), p = d.data, vis = new Uint8Array(w * h), fila = [], k, i, px, py;
          for (i = 0; i < w; i++) fila.push(i, (h - 1) * w + i);
          for (i = 0; i < h; i++) fila.push(i * w, i * w + w - 1);
          while (fila.length) {
            k = fila.pop(); if (vis[k]) continue; vis[k] = 1;
            if (!claro(p, k * 4, 234)) continue;
            p[k * 4 + 3] = 0; px = k % w; py = (k - px) / w;
            if (px > 0) fila.push(k - 1); if (px < w - 1) fila.push(k + 1);
            if (py > 0) fila.push(k - w); if (py < h - 1) fila.push(k + w);
          }
          for (k = 0; k < w * h; k++) {
            if (p[k * 4 + 3] === 0 || !claro(p, k * 4, 200)) continue;
            px = k % w; py = (k - px) / w;
            if ((px > 0 && p[(k - 1) * 4 + 3] === 0) || (px < w - 1 && p[(k + 1) * 4 + 3] === 0) || (py > 0 && p[(k - w) * 4 + 3] === 0) || (py < h - 1 && p[(k + w) * 4 + 3] === 0)) p[k * 4 + 3] = 110;
          }
          x.putImageData(d, 0, 0);
          img.src = c.toDataURL('image/png');
          img.closest('.cyg-qb-moeda') && img.closest('.cyg-qb-moeda').classList.add('is-recortada');
        } catch (e) {}
      };
      im.src = img.src;
    }
    function tudo() { [].forEach.call(document.querySelectorAll('.cyg-qb-moeda img'), recorta); }
    if (document.readyState !== 'loading') tudo(); else document.addEventListener('DOMContentLoaded', tudo);
  })();
} catch (e) { console.error('[cyg] bloco 12', e); }
